<script>
    export let width = 150;
    export let height = 10;
    export let percent = 0;
</script>

<svg class="progressbar" viewBox="0 0 {width} {height}" {width} {height} xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" rx="1" ry="1" {width} {height} style="fill:#d0d0d0;stroke:black;stroke-width:1;opacity:0.5" />
    <rect
        x="0"
        y="0"
        rx="1"
        ry="1"
        width={percent * width}
        {height}
        style="fill:#0080e1;stroke:black;stroke-width:1;opacity:1.0" />
</svg>

<style>
    .progressbar {
        overflow: visible;
    }
</style>
